import React, { Component } from 'react';
import LeftMenu from '../components/AdverchaApp/LeftMenu';
import { Grid } from 'semantic-ui-react';
import './styles.css';
import ResponsiveDrawing from '../components/AdverchaApp/ResponsiveDrawing';

export default class AdverchaApp extends Component {
  render() {
    return (
      <Grid>
        <Grid.Row stretched>
          <Grid.Column computer={1} tablet={2} mobile={2}>
            <LeftMenu />
          </Grid.Column>
          <Grid.Column computer={15} tablet={14} mobile={14}>
            <ResponsiveDrawing />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}
